module.exports = __webpack_public_path__ + "img/gameclass.9d29da34.png";